// extracted by mini-css-extract-plugin
export default {"iconBtn":"Icon_iconBtn__xylRP"};